import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class ContactEventQueryCriteriaClass extends BaseCriteriaModel {
  hdr_guid?: Optional<string> = Optional.empty();
  line_guid?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
  event_code?: Optional<string> = Optional.empty();
}

export class ContactEventCriteriaModelQuery {
  query = '';

  constructor(contactEventCriteriaModel: ContactEventQueryCriteriaClass) {

    if (!contactEventCriteriaModel) {
      return;
    }

    this.query += contactEventCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');
    this.query += contactEventCriteriaModel.line_guid.filter(x => x !== '').map(x => '&line_guid=' + x).orElse('');
    this.query += contactEventCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += contactEventCriteriaModel.event_code.filter(x => x !== '').map(x => '&event_code=' + x).orElse('');

    this.query += '&status=' + contactEventCriteriaModel.status;
    this.query += '&orderBy=' + contactEventCriteriaModel.orderBy;
    this.query += '&order=' + contactEventCriteriaModel.order;
    this.query += '&offset=' + contactEventCriteriaModel.offset + '&limit=' + contactEventCriteriaModel.limit;
  }
}
